// @ts-nocheck

import { createSelector } from 'reselect';

const getImmersiveItem = (state) => state.immersive.item;
const getImmersiveStatus = (state) => state.immersive.status;
const getImmersiveMessage = (state) => state.immersive.message;
const getImmersiveStake = (state) => state.immersive.stake;

export const getBetTitle = createSelector([getImmersiveItem], (immersiveBet) => {
  return immersiveBet.betTitle || null;
});

export const getOutcomeLabel = createSelector([getImmersiveItem], (immersiveItem) => {
  return immersiveItem.outcomeLabel || null;
});

export const getOddId = createSelector([getImmersiveItem], (immersiveItem) => {
  return immersiveItem.oddId || null;
});

export const getOddValue = createSelector([getImmersiveItem], (immersiveItem) => {
  return immersiveItem.value || null;
});

export const getValueHasChanged = createSelector([getImmersiveItem], (immersiveItem) => {
  return immersiveItem.valueHasChanged || null;
});

export const getValidatedValue = createSelector([getImmersiveItem], (immersiveItem) => {
  return immersiveItem.validatedValue || null;
});

export const basketSelector = createSelector(
  [
    getBetTitle,
    getOutcomeLabel,
    getOddId,
    getOddValue,
    getValidatedValue,
    getValueHasChanged,
    getImmersiveStake,
    getImmersiveStatus,
    getImmersiveMessage,
  ],
  (betTitle, outcomeLabel, oddId, value, validatedValue, valueHasChanged, stake, status, message) => ({
    betTitle,
    outcomeLabel,
    oddId,
    value,
    validatedValue,
    valueHasChanged,
    stake,
    status,
    message,
  }),
);
